(() => {
  'use strict';

  const script = document.querySelector('script[data-produce-lovers-conversions]');
  if (!script) return;

  const measurementId = script.dataset.ga4Id;
  const context = {
    page_type: script.dataset.pageType || 'unknown',
    market: script.dataset.market || 'unknown',
    language: document.documentElement.lang || 'unknown',
    page_path: window.location.pathname,
  };
  const seen = new Set();

  const clean = (value, fallback = 'unknown') => {
    const normalized = String(value || fallback).toLowerCase().replace(/[^a-z0-9_:-]+/g, '_');
    return normalized.slice(0, 100);
  };

  function analyticsAllowed() {
    try {
      return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
    } catch (_) {
      return false;
    }
  }

  function configureGa4() {
    if (!measurementId || !analyticsAllowed()) return false;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };

    if (!window.__produceLoversGa4Configured) {
      window.__produceLoversGa4Configured = true;
      if (!document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${measurementId}"]`)) {
        const gaScript = document.createElement('script');
        gaScript.async = true;
        gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
        document.head.appendChild(gaScript);
      }
      window.gtag('js', new Date());
      window.gtag('config', measurementId, { send_page_view: false });
    }
    return true;
  }

  function emit(name, parameters = {}, dedupeKey = '') {
    const payload = { ...context, ...parameters };
    const key = dedupeKey && `${name}:${dedupeKey}`;
    if (key && seen.has(key)) return;
    if (key) seen.add(key);

    try {
      window.Shopify?.analytics?.publish(`produce_lovers:${name}`, payload);
    } catch (_) {
      // Shopify's event bus can be unavailable briefly while the storefront initializes.
    }
    if (configureGa4()) window.gtag('event', name, payload);
  }

  function formDetails(host) {
    const root = host.closest('[data-forms-id]');
    const formId = (root?.dataset.formsId || '').replace('forms-root-', '');
    const map = {
      '796014': 'general_contact',
      '515035': 'grower_partnership',
      '515002': 'content_download',
    };
    return { form_id: clean(formId), lead_type: map[formId] || 'shopify_form' };
  }

  function inspectFormHost(host) {
    const shadow = host.shadowRoot;
    if (!shadow) return false;
    const app = shadow.querySelector('#app-embed');
    if (!app) return false;

    const reportSuccess = () => {
      if (app.getAttribute('data-current-step') !== 'success') return;
      const details = formDetails(host);
      const key = `${details.form_id}:${context.page_path}`;
      if (sessionStorage.getItem(`pl-lead:${key}`)) return;
      sessionStorage.setItem(`pl-lead:${key}`, '1');
      emit('generate_lead', details, key);
    };

    reportSuccess();
    new MutationObserver(reportSuccess).observe(app, { attributes: true, attributeFilter: ['data-current-step'] });
    return true;
  }

  function watchShopifyForms() {
    const pending = new WeakSet();
    const attach = (host) => {
      if (pending.has(host)) return;
      pending.add(host);
      let attempts = 0;
      const timer = window.setInterval(() => {
        attempts += 1;
        if (inspectFormHost(host) || attempts >= 40) window.clearInterval(timer);
      }, 250);
    };

    document.querySelectorAll('shopify-forms-embed').forEach(attach);
    new MutationObserver((mutations) => {
      mutations.forEach(({ addedNodes }) => addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches('shopify-forms-embed')) attach(node);
        node.querySelectorAll?.('shopify-forms-embed').forEach(attach);
      }));
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function trackConfirmedNativeForms() {
    if (document.querySelector('#ContactForm .form-status-list')) {
      emit('generate_lead', { form_id: 'native_contact', lead_type: 'general_contact' }, `native:${context.page_path}`);
    }
    document.querySelectorAll('.newsletter-form__message--success').forEach((message, index) => {
      emit('sign_up', { method: 'newsletter' }, `newsletter:${context.page_path}:${index}`);
    });
  }

  function trackIntentClicks() {
    document.addEventListener('click', (event) => {
      const link = event.target.closest?.('a[href]');
      if (!link) return;
      const url = new URL(link.href, window.location.origin);
      const href = link.getAttribute('href') || '';

      if (/^mailto:/i.test(href)) {
        emit('contact_click', { contact_method: 'email' });
      } else if (/^tel:/i.test(href)) {
        emit('contact_click', { contact_method: 'phone' });
      } else if (/wa\.me|whatsapp/i.test(href)) {
        emit('contact_click', { contact_method: 'whatsapp' });
      } else if (url.origin === window.location.origin && /^\/pages\/(contact|supply|partner-with-us|work-with-us)\/?$/.test(url.pathname)) {
        emit('lead_cta_click', {
          cta_destination: clean(url.pathname.replace(/^\/pages\//, '')),
          link_text: clean(link.textContent),
        });
      }
    }, { capture: true });
  }

  document.addEventListener('visitorConsentCollected', configureGa4);
  watchShopifyForms();
  trackConfirmedNativeForms();
  trackIntentClicks();
})();
